import React, { Component } from 'react';

function formatRating(rating) {
  return Math.round(1500 + 400 / Math.log(10) * rating);
}

const INITIAL_GAMES_LIMIT = 10;
const RATING_WEIGHT = 1;
const LIFETIME = 365 * 86400 * 1000;

function gameWeight(time, entry) {
  return RATING_WEIGHT * Math.min(entry.ratings[0], entry.ratings[1]) - (time - entry.game.time) / LIFETIME;
}

function compareGames(a, b) {
  const time = Date.now();
  return gameWeight(time, b) - gameWeight(time, a);
}

function formatPlayer(players, entry, player) {
  return players[entry.game.players[player]] + ' (' + formatRating(entry.ratings[player]) + ')';
}

function formatMove(move) {
  return move[0] + (move.codePointAt(1) - 'a'.codePointAt(0) + 1);
}

function filterGames(props) {
  const filteredGames = [];
  for (let entry of props.gamesWithRatings) {
    if (entry.game.moves.length < props.moves.length) {
      continue;
    }
    let match = true;
    for (let i = 0; i < props.moves.length; i++) {
      if (entry.game.moves[i] !== props.moves[i]) {
        match = false;
        break;
      }
    }
    if (match) {
      filteredGames.push(entry);
    }
  }
  filteredGames.sort(compareGames);
  return filteredGames;
}

export default class GameList extends Component {
  constructor(props) {
    super(props);
    this.state = {limit: INITIAL_GAMES_LIMIT, games: filterGames(props)};
  }

  componentWillReceiveProps(nextProps) {
    let changed = false;
    if (nextProps.size !== this.props.size) {
      changed = true;
    } else if (nextProps.gamesWithRatings.length !== this.props.gamesWithRatings.length) {
      changed = true;
    } else if (nextProps.moves.length !== this.props.moves.length) {
      changed = true;
    } else {
      for (let i = 0; i < this.props.moves.length; i++) {
        if (this.props.moves[i] !== nextProps.moves[i]) {
          changed = true;
          break;
        }
      }
    }
    if (changed) {
      this.setState({limit: INITIAL_GAMES_LIMIT, games: filterGames(nextProps)});
    }
  }

  render() {
    const gameElements = [];
    for (let entry of this.state.games.slice(0, this.state.limit)) {
      const gameUri = 'https://www.littlegolem.net/jsp/game/game.jsp?gid=' + entry.game.id;
      let nextMove = null;
      if (this.props.moves.length < entry.game.moves.length) {
        nextMove = entry.game.moves[this.props.moves.length];
      }
      gameElements.push(
        <div className="gameData" key={entry.game.id}>
          <div className="gameTitle">
            <a href={gameUri}>#{entry.game.id}</a> - {new Date(entry.game.time).toISOString().substring(0, 10)}
          </div>
          <div className="gamePlayers">
            {formatPlayer(this.props.gamedata.players, entry, 0)} : {formatPlayer(this.props.gamedata.players, entry, 1)}
          </div>
          <div className="gameResult">
            Winner: {(entry.game.winner === entry.game.swapped) ? 'Red' : 'Blue'}{', '}
            {this.props.gamedata.players[entry.game.players[entry.game.winner]]}
          </div>
          {nextMove == null ? null :
            <div><a className="nextLink" onClick={() => this.props.onMove(nextMove)}>Next move: {formatMove(nextMove)}</a></div>
          }
        </div>
      );
    }
    const moreLink = this.state.limit >= this.state.games.length ? null :
      <a className="moreLink" onClick={() => this.setState({limit: 2 * this.state.limit})}>More...</a>;
    return (
      <div className="gameList">
        <h3>Games ({this.state.games.length})</h3>
        <div>
          {gameElements}
          {moreLink}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/GameList.js